import { useContext } from "react";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setOrden } from "_+_Portal/_-_Autocheckin/context/action/orden";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { ContainerAutorizacion } from "./localStyle";
import { Camera, CameraResultType } from "@capacitor/camera";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import ConfirmAutorizacion from "../../components/ConfirmAutorizacion/ConfirmAutorizacion";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";

const RequiereAutorizacion = ({ turnoActual, setLoading }) => {
  //#region -------- useContext -------------
  const {
    pasoDispatch,

    turnosSeleccionadosState,
    ordenDispatch,
    puntoControlDispatch,
  } = useContext(AutocheckContext);

  const { modalDispatch } = useContext(GlobalContext);
  //#endregion ----- useContext -------------

  //#region -------- constant -------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];

  const turno = listTurnosSeleccionado[turnoActual];

  const medico = turno?.medico;
  const especialidad = turno?.especialidad;

  //#endregion ----- constant -------------

  //#region -------- funtions -------------
  const tomarFoto = () => {
    const takePicture = async () => {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.DataUrl,
      });
      const imageUrl = image.dataUrl;
      showModal(
        <ConfirmAutorizacion
          image={imageUrl}
          idturno={turno?.idturno}
          isDorso={true}
          dismiss={dismiss}
          turnoActual={turnoActual}
        />,
        "Autorizacion de orden",
        dismiss,
        false,
        {},
        "centro",
        true
      )(modalDispatch);
    };
    takePicture();
  };
  const dismiss = (limpiarOrden) => {
    hideModal()(modalDispatch);
    if (limpiarOrden) {
      setOrden([])(ordenDispatch);
    }
  };

  const handleClickVolver = () => {
    setPaso("TurnosDelDia")(pasoDispatch);
  };
  const handleClickSuccess = () => {
    tomarFoto();
    // setOrden([...ordenState.orden.data])(ordenDispatch);
  };
  const handleClickFail = () => {
    const idTipoPuntoControl = 4;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  //#endregion ----- funtions -------------

  return (
    <LayoutPasos
      handleClick={handleClickVolver}
      type={"no-circle"}
      title={"autorización de orden"}
    >
      <CardBlueHeart
        medico={medico ? medico : especialidad}
        turnoTitle={especialidad}
        pasoActual={turnoActual + 1}
        pasoTotal={listTurnosSeleccionado.length}
      />
      <ContainerAutorizacion
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <div className="text-container">
          <span>El estudio requiere de autorización de su cobertura</span>
          <div className="ValidaTurno-separador"></div>
          <span>¿Cuenta con dicha autorización en papel?</span>
        </div>
        <div className="btn-container">
          <button className="btn success" onClick={handleClickFail}>
            NO
          </button>
          <button className="btn danger" onClick={handleClickSuccess}>
            SI
          </button>
        </div>
      </ContainerAutorizacion>
    </LayoutPasos>
  );
};

export default RequiereAutorizacion;
